
function useEndpoints() {


    var EXTERNAL_IP = new URL(process.env.REACT_APP_BASE_URL)
    var INTERNAL_IP = new URL(process.env.REACT_APP_BASE_URL_INTERNAL)


    const url = window.location.hostname.includes(INTERNAL_IP.hostname) ?
        INTERNAL_IP.href :
        window.location.hostname.includes('localhost') ? INTERNAL_IP.href : EXTERNAL_IP.href;

    var webService = url + 'api/v1/web/customer/'

    const endpoints = {
        image: url + "api/v1/AR922683182EM-IR/filio/",
        login: webService + "public/login",
        verify: webService + "public/verify",
        baseInfo: webService + "public/base",

        destAddress: webService + "private/dest-address",
        prices: webService + "private/prices",
        packetTypes: webService + "private/packet-types",
        vehicle: webService + "private/vehicle",
        insertService: webService + "private/service/insert",
        doingService: webService + "private/service/doing",
        finishedService: webService + "private/service/finished",
        canceledService: webService + "private/service/canceled",
        messages: webService + "private/messages",
        refreshToken: webService + "private/refresh-token",
        password: webService + "private/password",
        address: webService + "private/address",
        balance: webService + "private/balance",
        forgetPassword: webService + "public/forget-password",
        register: webService + "public/register",
        mobileIdentity: webService + "public/mobile-identity",
        // service: webService + "private/service/service",
        service: webService + "private/service",
        favoriteAddress: webService + "private/favorite",
        calcPrice: webService + "private/calc-price",
        getBasicInfo: webService + "private/basic-info",
        loc2add: webService + "public/map/loc2addr",
        search: webService + "public/map/search",
        saveLocation: webService + "public/save-location",
        getEshAddress: webService + "public/esh-address",
    }

    return endpoints
}

export default useEndpoints